module.exports = __webpack_public_path__ + "img/img_s_t2.620eb053.png";